import styled from "styled-components";

export const StyledNotificationBannerWrapper = styled.div`
    margin-top: 8px;
`;

export const StyledTechnologiesSignalFiltersWrapper = styled.div`
    margin-top: -4px;
    max-width: 715px;
`;
